import styled from "styled-components";
import { TooltipHost, DefaultButton } from "@fluentui/react";
import { CopyIcon } from '@fluentui/react-icons-mdl2';

export const TableStyled = styled.table`
    width: 100%;
    border-spacing: 0;
    overflow: hidden;
    thead
    {
        text-align: left;
        border-top-right-radius: 30px;
        th
        {
            border-spacing: 0;
            padding: 0;
            div
            {
                padding-top: 17px;
                padding-right: 22px;
                padding-bottom: 17px;
            }
        }
        th:first-of-type
        {
            div
            {
                padding-left: 10px;
                border-top-left-radius: 30px;
            }
        }
        th:last-of-type
        {
            div
            {
                padding-right: 10px;
                border-top-right-radius: 30px;
            }
        }
    }
    tbody
    {
        button.expanded
        {
            border: none;
            cursor: pointer;
            transition: 150ms;
            border-radius: 0;
            &:hover
            {
                border-bottom: 1px solid #4284e6;
                transition: 150ms;
            }
        }
        strong
        {
            color: ${props => props?.theme?.palette?.black}
        }
        tr
        {
            td
            {
                border-bottom: 2px solid #ecf1f3;
                padding-right: 18px;
                div
                {
                    padding: 8px 0;
                }
                p
                {
                    color: ${props => props?.theme?.palette?.black}
                }
            }
            svg
            {
                margin-right: 3px;
            }
            .max-content
            {
                min-width: max-content;
                padding-right: 8px;
                display: flex;
                align-items: center;
            }
        }
        tr:last-of-type
        {
            td
            {
                border-bottom: none;
            }
        }
        tr.container-table td:first-of-type
        {
            padding: 0;
        }
    }
`;

export const SubTableInternalStyled = styled.div`
    div
    {
        width: 100%;
        min-width: max-content;
        padding: 4px 0 !important;
    }
    margin: 15px 20px;
    margin-left: 10px !important;
    table
    {
        tr
        {
            line-height: 2rem;
        }
        color: ${props => props?.theme?.palette?.black};
        box-shadow: rgb(101 119 134 / 20%) 0px 0px 15px;
        border-radius: 16px;
        th div,
        td div
        {
            text-align: left;
            margin: 0 !important;
        }
        th,
        td
        {
            padding-left: 20px !important;
            padding-right: 15px !important;
        }
    }
`;

export const FundName = styled.div`
    .brothers-btn-icon
    {
        margin-right: 5px;
        vertical-align: baseline;
    }
`;

export const ScoreTooltipContainer = styled.div`
    background: linear-gradient(135deg, #CC214F 0%, #A01B40 100%);
    padding: 16px;
    color: white;
    box-shadow: 0 8px 32px rgba(204, 33, 79, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    min-width: 200px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

    .score-header
    {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        
        .score-title
        {
            font-weight: 600;
            font-size: 14px;
            color: white;
        }
        
        .score-badge
        {
            background: rgba(255, 255, 255, 0.25);
            padding: 4px 12px;
            border-radius: 20px;
            font-weight: 700;
            font-size: 14px;
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.3);
        }
    }

    .score-bar-container
    {
        margin-bottom: 8px;
        
        .score-label
        {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.9);
            margin-bottom: 6px;
            font-weight: 500;
        }
        
        .score-bar
        {
            width: 100%;
            height: 8px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid rgba(255, 255, 255, 0.1);
            
            .score-fill
            {
                height: 100%;
                background: linear-gradient(90deg, #f0f0f0, #ffffff, #f8f8f8);
                border-radius: 4px;
                transition: width 0.3s ease;
                box-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
            }
        }
    }

    .score-description
    {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.4;
        margin-top: 8px;
    }
`;

export const ScoreTooltipHost = styled(TooltipHost)`
    padding: 0px !important;
    overflow: hidden;
    background: transparent !important;
`;

export const CopyButtonStyled = styled(DefaultButton)`
    padding: 0 5px;
    padding-right: 15px;
    margin-left: 5px;
    border: 0;
    background: none;

    &:hover,
    &:active
    {
        background: none;
    }

    &.compact
    {
        font-size: 10px;
        padding: 1px 3px;
        padding-top: 2px;
        margin-left: 0;
        padding-right: 0;
        min-width: auto;
        height: 16px;
        line-height: 14px;
        vertical-align: middle;
    }
`;

export const AddToCartButtonStyled = styled(DefaultButton)`
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid #CC214F;
    background: #CC214F;
    color: white;
    border-radius: 50%;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    
    &:hover
    {
        background: white;
        border-color: #CC214F;
        color: #CC214F;
        transform: scale(1.05);
        box-shadow: 0 2px 8px rgba(204, 33, 79, 0.3);
    }
    
    &:active
    {
        background: #f5f5f5;
        border-color: #A01B40;
        color: #A01B40;
        transform: scale(0.98);
    }
`;

export const ISINContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    line-height: 1.1;
    margin-left: 0;
    padding-left: 0;
`;

export const CompactCopyIcon = styled(CopyIcon)`
    font-size: 12px;
`;

export const FundCellContainer = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    color: #4284e6;
    padding-bottom: 0 !important;
    
    &:hover
    {
        color: #4284e6;
    }
`;

export const FundNameRow = styled.div`
    margin-bottom: 2px;
    line-height: 1.1;
`;

export const ISINRow = styled.span`
    display: inline;
`;

export const FundInternalTableStyled = styled.table`
    width: 100%;
    border-spacing: 0;
    overflow: hidden;
    cursor: default;
    border-radius: 16px;
    
    thead
    {
        text-align: left;
        border-top-right-radius: 16px;
        th
        {
            border-spacing: 0;
            padding: 0;
            div
            {
                padding-top: 17px;
                padding-right: 20px;
                padding-bottom: 17px;
                svg
                {
                    width: 20px;
                    height: 20px;
                    position: relative;
                    top: -4px;
                    left: 3px;
                }
            }
        }
        th:first-of-type
        {
            div
            {
                padding-left: 10px;
                border-top-left-radius: 16px;
            }
        }
        th:last-of-type
        {
            div
            {
                padding-right: 10px;
                border-top-right-radius: 16px;
            }
        }
    }
    tbody
    {
        button.expanded
        {
            border: none;
            cursor: pointer;
            transition: 150ms;
            border-radius: 0;
            background: transparent;
            
            &:hover
            {
                border-bottom: 1px solid #4284e6;
                transition: 150ms;
            }
        }
        strong
        {
            color: #4284e6;
        }
        tr
        {
            td
            {
                border-bottom: 2px solid #ecf1f3;
                padding-right: 16px;
                div
                {
                    padding: 10px 0;
                }
                p
                {
                    color: #9ca6a6;
                }
            }
            svg
            {
                margin-right: 3px;
            }
            .max-content
            {
                min-width: max-content;
                padding-right: 8px;
                display: flex;
                align-items: center;
            }
        }
        tr:last-of-type
        {
            td
            {
                border-bottom: none;
            }
        }
        tr.container-table td:first-of-type
        {
            padding: 0;
        }
    }
`;